import React from 'react';

import { BearingEnvelope } from '@paragon/contract-library';
import { getEnvelopeSegment } from '@paragon/layout';

import { OptimizedDistanceDimension } from '../../dimension/OptimizedDistanceDimension';

const DIMENSION_OFFSET = -10;

export function BearingEnvelopeDimension(props: { envelope: BearingEnvelope }) {
  const dimensionSegment = getOffsetBearingEnvelopeDimension(props.envelope);
  if (dimensionSegment == null) return null;

  return (
    <OptimizedDistanceDimension
      distance={dimensionSegment.length}
      start={dimensionSegment.basePoint}
      end={dimensionSegment.endPoint}
      elevation={props.envelope.bottom}
    />
  );
}

export function getOffsetBearingEnvelopeDimension(envelope: BearingEnvelope) {
  const definitionSegment = getEnvelopeSegment(envelope);
  if (definitionSegment == null) return null;

  const offset = definitionSegment.direction.rotateQuarterTurn().toVector(DIMENSION_OFFSET);
  const dimensionSegment = definitionSegment.translate(offset);

  return dimensionSegment;
}
